module.exports = __webpack_public_path__ + "static/herbapp-image-top-75-percent-189dca746ccf27b56fc51644065cd1c5.png";